import { render, staticRenderFns } from "./faultManage.vue?vue&type=template&id=928e89c4&scoped=true"
import script from "./faultManage.vue?vue&type=script&lang=js"
export * from "./faultManage.vue?vue&type=script&lang=js"
import style0 from "./faultManage.vue?vue&type=style&index=0&id=928e89c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928e89c4",
  null
  
)

export default component.exports